export default class ManagementUnitDto {
    constructor(object) {
        this.id = object.id
        this.code = object.code
        this.name = object.name
        this.labelWithCode = `${object.name} [${object.code}]`
        this.creationDate = object.creationDate
        this.ugeCode = object.ugeCode
        this.sispeaCode = object.sispeaCode
        this.referentCode = object.referentCode
        this.productionSkill = object.productionSkill
        this.protectionSkill = object.protectionSkill
        this.treatmentSkill = object.treatmentSkill
        this.transportSkill = object.transportSkill
        this.storageSkill = object.storageSkill
        this.distributionSkill = object.distributionSkill
        this.ccspl = object.ccspl ?? false
        this.email = object.email
        this.contactTitle = object.contactTitle
        this.contactPhone = object.contactPhone
        this.openHours = object.openHours
        this.link_cities = object.link_cities ?? []
        this.headers = ['id', 'code', 'name', 'ugeCode', 'sispeaCode', 'email', 'contactPhone']
    }
}